import { useAppContext } from '../context/useAppContext';
import UserPermission from '../models/Account/UserPermission';

const useUserPermissions = (): UserPermission[] | undefined => {
  const {
    state: { user },
  } = useAppContext();

  if (user?.permissions) return user.permissions;
  return undefined;
};

export default useUserPermissions;
